import { LeadForm, LeadSectionForm } from "../components";
import LeadSectionContactHero from "../components/contact_hero";
import LeadSectionContactInfo from "../components/contact_info";
import styles from "./contact.module.scss";

export const LeadTemplateContact = ({ pageData }) => {
  return (
    <>
      <LeadSectionContactHero pageData={pageData} />
      <LeadSectionContactInfo pageData={pageData} />
      <section>
        <div className="container">
          <div className={styles.form_wrapper}>
            <LeadForm pageData={pageData} />
          </div>
        </div>
      </section>
    </>
  );
};

export default LeadTemplateContact;
